import React from "react";

type Props = {
  rows?: number;
  isDarkMode?: boolean;
};

const Cell = ({ className, isDarkMode }: { className: string; isDarkMode: boolean }) => (
  <div className={`h-3 rounded animate-pulse ${isDarkMode ? "bg-gray-700" : "bg-gray-200"} ${className}`} />
);

export const UsersTableSkeleton: React.FC<Props> = ({ rows = 10, isDarkMode = false }) => {
  return (
    <>
      {Array.from({ length: rows }).map((_, i) => (
        <tr
          key={i}
          className={`transition-all duration-300 ${
            isDarkMode
              ? `${i % 2 === 0 ? "bg-gray-800/60" : "bg-gray-700/30"}`
              : `${i % 2 === 0 ? "bg-white/60" : "bg-blue-50/30"}`
          }`}
        >
          {/* Name & ID */}
          <td className="px-8 py-5 whitespace-nowrap">
            <div className="space-y-2">
              <Cell className="w-32 mx-auto" isDarkMode={isDarkMode} />
              <div
                className={`max-w-xs mx-auto px-3 py-2 rounded-lg border shadow-sm ${
                  isDarkMode
                    ? "bg-gray-700 border-gray-600"
                    : "bg-gradient-to-r from-blue-100 to-indigo-100 border-blue-200/50"
                }`}
              >
                <Cell className="w-24" isDarkMode={isDarkMode} />
              </div>
            </div>
          </td>
          {/* Email */}
          <td className="px-8 py-5 whitespace-nowrap">
            <Cell className="w-40 mx-auto" isDarkMode={isDarkMode} />
          </td>
          {/* Roles */}
          <td className="px-8 py-5 whitespace-nowrap">
            <div className="flex flex-wrap gap-2 justify-center">
              <div
                className={`h-7 w-20 rounded-full animate-pulse ${
                  isDarkMode ? "bg-gray-700" : "bg-gray-200"
                }`}
              />
              <div
                className={`h-7 w-16 rounded-full animate-pulse ${
                  isDarkMode ? "bg-gray-700" : "bg-gray-200"
                }`}
              />
            </div>
          </td>
          {/* Session */}
          <td className="px-8 py-5 whitespace-nowrap">
            <div className="flex items-center justify-center">
              <div
                className={`w-6 h-6 rounded-full animate-pulse ${
                  isDarkMode ? "bg-gray-700" : "bg-gray-200"
                }`}
              />
            </div>
          </td>
          {/* Created At */}
          <td className="px-8 py-5 whitespace-nowrap">
            <div
              className={`mx-auto px-4 py-2 rounded-xl border shadow-sm ${
                isDarkMode
                  ? "bg-gray-700 border-gray-600"
                  : "bg-gradient-to-r from-purple-50 to-pink-50 border-purple-200/50"
              }`}
            >
              <Cell className="w-24" isDarkMode={isDarkMode} />
            </div>
          </td>
          {/* Actions */}
          <td className="px-8 py-5 whitespace-nowrap">
            <div className="flex justify-center">
              <div
                className={`h-12 w-12 rounded-xl animate-pulse ${
                  isDarkMode ? "bg-gray-700" : "bg-gray-200"
                }`}
              />
            </div>
          </td>
        </tr>
      ))}
    </>
  );
};

export default UsersTableSkeleton;
